<template>
  <div class="sideBar">
    <!-- 顶部标题栏 -->
    <div class="sideBarTitle">
      <div class="left" @click="clickOpenNewChat">
        <img
          class="AI_head_icon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/AI_head_icon.png"
          alt=""
        />
        <img
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/AI_text.png"
          alt=""
          class="AI_text"
        />
      </div>
      <div class="right" @click="closeLeftSideBar">
        <img
          class="leftSideBarIcon"
          src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/leftSideBarIcon.png"
          alt=""
        />
        <div class="popover">
          <smallPopover position="bottom" text="收起边栏"></smallPopover>
        </div>
      </div>
    </div>
    <div class="sideBarContent">
      <div class="newChatBox_box">
        <div class="newChatBox" @click="clickOpenNewChat">
          <img
            class="newChatIcon"
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/newChatIcon.png"
            alt=""
          />
          <div class="newChatText">新对话</div>
        </div>
      </div>

      <div class="centerLine"></div>
      <div class="chatListBox">
        <!-- 发现 -->
        <div class="listBox" v-if="findList.length > 0">
          <div class="listTitleBox">
            <div class="left">发现</div>
          </div>
          <div class="list">
            <div
              class="listItem"
              v-for="(value, key) in findList"
              :key="key"
              @click="clickFindItem(value)"
            >
              <img class="leftIcon" :src="value.icon" alt="" />
              <div class="right">
                <div class="chatName">
                  {{ value.name }}
                </div>
                <div class="vipTag" v-show="value.vipOnly == 1">会员专属</div>
              </div>
            </div>
            <div
              class="moreItem"
              @click.stop="clickMoreItem($event)"
              v-if="moreChatList.length > 0"
            >
              <img
                class="leftIcon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/chatListMore.png"
                alt=""
              />
              <div class="right">
                <div class="chatName">更多</div>
                <img
                  class="rightArrow_gray"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/rightArrow_gray.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 分割线 -->
        <div class="divider"></div>
        <!-- 对话列表 -->
        <div class="listBox" v-if="isLogin">
          <div class="listTitleBox">
            <div class="left">对话列表</div>
            <div
              class="right"
              :class="{
                limit: totalTokenCount - currentTokenCount <= 0,
              }"
              v-if="
                totalTokenCount - currentTokenCount <= 0 && totalTokenCount != 0
              "
            >
              <span>今日剩余会话字数 </span>
              <span
                >{{ totalTokenCount - currentTokenCount }}/{{
                  totalTokenCount
                }}</span
              >
            </div>
            <div
              class="right"
              :class="{
                limit: (isVip ? vipTotalCount : totalCount) - currentCount <= 0,
              }"
              v-else
            >
              <span>今日剩余会话条数 </span>
              <span
                >{{
                  (isVip ? vipTotalCount : totalCount) - currentCount <= 0
                    ? 0
                    : (isVip ? vipTotalCount : totalCount) - currentCount
                }}/{{ isVip ? vipTotalCount : totalCount }}</span
              >
            </div>
          </div>
          <div class="list">
            <div
              class="listItem"
              :class="{
                listItem_active:
                  currentChat &&
                  value.ai_app_code == currentChat.ai_app_code &&
                  value.conversation_id == currentChat_conversation_id,
              }"
              v-for="(value, key) in historyList"
              :key="key"
              @click="clickHistoryChatItem(value)"
            >
              <img class="leftIcon" :src="value.icon" alt="" />
              <div class="right">
                <div class="chatName">
                  {{ value.name }}
                </div>
                <img
                  v-show="value.topUpFlag == 1"
                  class="setTopIcon"
                  src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/setTopIcon_gray.png"
                  alt=""
                />
                <div class="vipTag" v-if="value.vipOnly == 1">会员专属</div>
              </div>
              <img
                class="chatItem_moreIcon"
                src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/pc/chatItem_moreIcon.png"
                alt=""
                @click.stop="clickChatOptions($event, value)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import smallPopover from "@/components/smallPopover/smallPopover";
export default {
  props: [
    "findList",
    "moreChatList",
    "historyList",
    "isLogin",
    "currentCount",
    "totalCount",
    "currentTokenCount",
    "totalTokenCount",
    "vipTotalCount",
    "currentChat",
    "currentChat_conversation_id",
    "isVip",
  ],
  components: {
    smallPopover,
  },
  data: function () {
    return {};
  },
  methods: {
    // 点击打开一个新对话
    clickOpenNewChat: function () {
      this.$emit("clickOpenNewChat");
    },
    // 点击对话列表中的更多按钮 弹出popover
    clickChatOptions: function ($event, value) {
      this.$emit("openPopover", $event, value);
    },
    // 鼠标悬浮至更多上，弹出popover
    clickMoreItem: function ($event) {
      this.$emit("openMoreChatPopover", $event);
    },
    // 点击收起侧边栏
    closeLeftSideBar: function () {
      this.$emit("closeLeftSideBar");
    },
    // 点击发现项
    clickFindItem: function (value) {
      this.$emit("clickFindItem", value);
    },
    // 点击对话列表项
    clickHistoryChatItem: function (value) {
      // 这里判断一下  如果点击的会话是当前活动的会话，则不进行任何操作
      if (
        this.currentChat &&
        value.ai_app_code == this.currentChat.ai_app_code &&
        value.conversation_id == this.currentChat_conversation_id
      ) {
        return;
      }
      this.$emit("clickHistoryChatItem", value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./sideBar.scss";
</style>
